import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d315e5ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("生成图片")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogHandle.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogHandle.visible) = $event)),
    title: "图片调整",
    width: 800,
    "close-on-click-modal": false,
    "before-close": _ctx.dialogHandle.close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.dialogHandle.submit
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.dialogHandle.showImages.length > 0)
        ? (_openBlock(), _createBlock(_component_draggable, {
            key: 0,
            modelValue: _ctx.dialogHandle.showImages,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogHandle.showImages) = $event)),
            "item-key": "id"
          }, {
            item: _withCtx(({element}) => [
              _createElementVNode("img", {
                src: element.src,
                class: "image-single"
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}